import { render, staticRenderFns } from "./cwCenterBottom.vue?vue&type=template&id=791f83f4"
import script from "./cwCenterBottom.vue?vue&type=script&lang=js"
export * from "./cwCenterBottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports